import type { ApiClientInstance } from '@bonboca/api-sdk';
import { createContext, useContext, type ReactNode } from 'react';

const ApiClientContext = createContext<ApiClientInstance | null>(null);

interface ApiClientProviderProps {
  client: ApiClientInstance;
  children: ReactNode;
}

export function ApiClientProvider({ client, children }: ApiClientProviderProps) {
  return <ApiClientContext.Provider value={client}>{children}</ApiClientContext.Provider>;
}

export function useApiClient(): ApiClientInstance {
  const client = useContext(ApiClientContext);
  if (!client) {
    throw new Error('useApiClient must be used within an ApiClientProvider');
  }
  return client;
}
